import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  fares: {
    data: [],
    meta: {
      total: 0,
    },
  },
  fareTypes: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the fares
export const fetchFares = createAsyncThunk(
  "fetchFares/fares",
  async ({ enqueueSnackbar, limit = 100, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`trips/fares`, {
        params: {
          page: page + 1,
          limit,
        },
      });

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: fetch all the
export const fetchFareTypes = createAsyncThunk(
  "fetchFareTypes/fares",
  async ({ enqueueSnackbar, limit = 100, page = 0 }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`trips/fare/types`);

      return {
        data: response.data.data.items,
        meta: {
          total: response.data.data.items.length,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create fare
export const createFare = createAsyncThunk(
  "createFare/fares",
  async ({ data, details, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`trips/fares`, data);
      thunkApi.dispatch(
        createOrUpdateFareDetail({
          details,
          fare_id: response.data.data.id,
          enqueueSnackbar,
        })
      );
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      console.log(error, "erororor");
      // return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create fare
export const createOrUpdateFareDetail = createAsyncThunk(
  "createOrUpdateFareDetail/fares",
  async ({ details, fare_id, enqueueSnackbar }, thunkApi) => {
    try {
      await details.forEach(async (detail) => {
        try {
          if (detail.detail_id) {
            await axiosInstance.patch(
              `trips/fare/details/${detail.detail_id}`,
              {
                ...detail,
              }
            );
          } else {
            await axiosInstance.post(`trips/fare/details`, {
              ...detail,
              fare_id,
            });
          }
        } catch (error) {
          return thunkApi.rejectWithValue({ error, enqueueSnackbar });
        }
      });

      return;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update fare
export const updateFareDetail = createAsyncThunk(
  "updateFareDetail/fares",
  async ({ details, id, enqueueSnackbar }, thunkApi) => {
    try {
      await axiosInstance.patch(`trips/fare/details/${id}`, {
        ...details,
      });

      return;
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create fare types
export const createFareType = createAsyncThunk(
  "createFareType/fares",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`trips/fare/types`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update fare
export const updateFare = createAsyncThunk(
  "updateFare/fares",
  async (
    { data, enqueueSnackbar, handleClose, id, details, setRefresh },
    thunkApi
  ) => {
    try {
      const response = await axiosInstance.patch(`trips/fares/${id}`, data);

      thunkApi.dispatch(
        createOrUpdateFareDetail({
          details,
          fare_id: response.data.data.id,
          enqueueSnackbar,
        })
      );
      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
        setRefresh,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update fare type
export const updateFareType = createAsyncThunk(
  "updateFareType/fares",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(
        `trips/fare/types/${id}`,
        data
      );

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete fare
export const deleteFare = createAsyncThunk(
  "deleteFare/fares",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`trips/fares/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete fare
export const deleteFareDetail = createAsyncThunk(
  "deleteFareDetail/fares",
  async (
    { enqueueSnackbar, handleClose, id, setRefresh, remove },
    thunkApi
  ) => {
    try {
      await axiosInstance.delete(`trips/fare/details/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
        setRefresh,
        remove,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete faretype
export const deleteFareType = createAsyncThunk(
  "deleteFareType/fares",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`trips/fare/types/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update fare status
export const updateFareStatus = createAsyncThunk(
  "updateFareStatus/fares",
  async ({ id, status, enqueueSnackbar }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`trips/fares/${id}`, {
        status,
      });

      return {
        id,
        status,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const fareslice = createSlice({
  name: "fare",
  initialState,
  extraReducers: (builder) => {
    // TODO: create fare
    builder.addCase(fetchFares.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchFares.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.fares = action.payload;
    });

    builder.addCase(fetchFares.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create fare
    builder.addCase(createFare.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createFare.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fares.data = [action.payload.data, ...state.fares.data];
      state.fares.meta.total = state.fares.meta.total + 1;
      action.payload.enqueueSnackbar("FARE is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createFare.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update fare
    builder.addCase(updateFare.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateFare.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fares.data = state.fares.data.map((fare) => {
        if (fare.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return fare;
        }
      });
      action.payload.enqueueSnackbar("FARE is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
      action.payload.setRefresh && action.payload.setRefresh((prev) => !prev);
    });

    builder.addCase(updateFare.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete fare
    builder.addCase(deleteFare.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteFare.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fares.data = state.fares.data.filter(
        (fare) => fare.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("FARE is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteFare.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: fetch fareType
    builder.addCase(fetchFareTypes.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchFareTypes.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.fareTypes = action.payload;
    });

    builder.addCase(fetchFareTypes.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: create fareType
    builder.addCase(createFareType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createFareType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fareTypes.data = [action.payload.data, ...state.fareTypes.data];
      state.fareTypes.meta.total = state.fareTypes.meta.total + 1;
      action.payload.enqueueSnackbar("FARETYPE is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createFareType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update fareType
    builder.addCase(updateFareType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateFareType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fareTypes.data = state.fareTypes.data.map((fareType) => {
        if (fareType.id === action.payload.data.id) {
          return action.payload.data;
        } else {
          return fareType;
        }
      });
      action.payload.enqueueSnackbar("FARETYPE is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateFareType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete fareType
    builder.addCase(deleteFareType.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteFareType.fulfilled, (state, action) => {
      state.isLoading = false;
      state.fareTypes.data = state.fareTypes.data.filter(
        (fareType) => fareType.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("FARE TYPE is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteFareType.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: error of creating fare details
    builder.addCase(createOrUpdateFareDetail.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: delete detail
    builder.addCase(deleteFareDetail.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteFareDetail.fulfilled, (state, action) => {
      state.isLoading = false;
      action.payload.fields = state.fares.data.map((fare) => {
        return {
          ...fare,
          details: fare.details.filter(
            (detail) => detail.id !== action.payload.data
          ),
        };
      });
      action.payload.remove && action.payload.remove();
      action.payload.enqueueSnackbar("FARE detail is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
      action.payload.setRefresh && action.payload.setRefresh((prev) => !prev);
    });

    builder.addCase(deleteFareDetail.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(
        JSON.stringify(
          action.payload.error ||
            action.payload.error.errors ||
            action.payload.error.message
        ),
        {
          variant: "error",
        }
      );
    });

    // TODO: update fare status
    builder
      .addCase(updateFareStatus.pending, (state, action) => {
        state.isLoading = true;
      })
      .addCase(updateFareStatus.fulfilled, (state, action) => {
        state.isLoading = false;

        // Find and update the specific fare's status
        const fareToUpdate = state.fares.data.find(
          (fare) => fare.id === action.payload.id
        );
        if (fareToUpdate) {
          fareToUpdate.status = action.payload.status;
        }

        // Optional: Show success notification
        action.payload.enqueueSnackbar(`Fare status updated successfully`, {
          variant: "success",
        });
      })
      .addCase(updateFareStatus.rejected, (state, action) => {
        state.fetchLoading = false;
        action.payload.enqueueSnackbar(
          action.payload.error.message || "Failed to update fare status",
          { variant: "error" }
        );
      });
  },
});

export default fareslice.reducer;
